import { Box, Typography, styled, IconButton } from "@mui/material";
import { colors } from "../../../../theme/colors";

export const SummarizedViewContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
});

export const SummarizedHeaderRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  height: "32px",
  marginBottom: "16px",
});

export const SummarizedTitle = styled(Typography)({
  fontSize: "18px",
  fontWeight: 600,
  color: colors.text.primary,
  fontFamily: "Sora",
});

export const EditIconButton = styled(IconButton)({
  padding: "4px",
  flexShrink: 0,
});


export const IntroParagraph = styled(Typography)({
  fontSize: "16px",
  color: colors.text.primary,
  fontFamily: "Nunito",
  lineHeight: "26px",
  marginBottom: "24px",
});

export const AppointmentBlock = styled(Box)({
  marginBottom: "20px",
});

export const AppointmentHeadingRow = styled(Box)({
  display: "flex",
  alignItems: "baseline",
  gap: "6px",
  marginBottom: "8px",
  flexWrap: "wrap",
});

export const AppointmentHeadingText = styled(Typography)({
  fontSize: "16px",
  fontWeight: 700,
  color: colors.text.primary,
  fontFamily: "Sora",
  lineHeight: "24px",
});

export const AppointmentOptionLabel = styled(Typography)({
  fontSize: "13px",
  fontWeight: 600,
  color: colors.text.secondary,
  fontFamily: "Sora",
  lineHeight: "24px",
});

export const TimeframeBadge = styled(Box)({
  display: "inline-flex",
  alignItems: "center",
  backgroundColor: colors.background.mediumBlue,
  borderRadius: "4px",
  padding: "2px 8px",
  fontSize: "12px",
  fontWeight: 600,
  color: colors.background.darkBlue,
  fontFamily: "Sora",
  whiteSpace: "nowrap",
});

export const BulletItem = styled(Typography)({
  fontSize: "15px",
  color: colors.text.primary,
  fontFamily: "Nunito",
  lineHeight: "24px",
  paddingLeft: "4px",
  display: "flex",
  alignItems: "flex-start",
  gap: "8px",
  marginBottom: "4px",
});

export const BulletDot = styled("span")({
  color: colors.primary.main,
  fontWeight: 700,
  flexShrink: 0,
  marginTop: "1px",
});

export const DescriptionLine = styled(Typography)({
  fontSize: "15px",
  color: colors.text.secondary,
  fontFamily: "Nunito",
  lineHeight: "24px",
  paddingLeft: "4px",
});

export const InfoBanner = styled(Box)({
  backgroundColor: colors.background.lightBlue,
  border: `1px solid ${colors.primary.main}`,
  borderRadius: "8px",
  padding: "12px 16px",
  display: "flex",
  gap: "10px",
  alignItems: "flex-start",
  marginBottom: "24px",
});

export const InfoBannerText = styled(Typography)({
  fontSize: "14px",
  color: colors.text.action,
  fontFamily: "Nunito",
  lineHeight: "22px",
});

export const WarningBox = styled(Box)({
  backgroundColor: colors.amber.background,
  border: `1px solid ${colors.amber.main}`,
  borderRadius: "8px",
  padding: "16px",
  display: "flex",
  gap: "12px",
  marginBottom: "24px",
});

export const WarningText = styled(Typography)({
  fontSize: "14px",
  color: colors.amber.text,
  fontFamily: "Nunito",
  lineHeight: "22px",
});

export const SectionLabel = styled(Typography)({
  fontSize: "11px",
  fontWeight: 700,
  color: colors.text.secondary,
  fontFamily: "Nunito",
  letterSpacing: "0.08em",
  marginBottom: "8px",
});

export const EditActions = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  gap: "16px",
  marginTop: "24px",
});

export const EditorErrorText = styled(Typography)({
  color: colors.status.error,
  fontSize: "12px",
  marginTop: "8px",
  display: "block",
});

